(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jhym-home"] && !Shopify.designMode) return;
  try {
    

(function () {
  var rail = document.querySelector('.cats');
  var prev = document.querySelector('.cat-arrow[data-cat-dir="-1"]');
  var next = document.querySelector('.cat-arrow[data-cat-dir="1"]');
  if (!rail || !prev || !next) return;

  function step() {
    var card = rail.querySelector('.cat');
    if (!card) return rail.clientWidth;
    var gap = parseFloat(getComputedStyle(rail).columnGap) || 10;
    return card.getBoundingClientRect().width + gap;
  }

  function sync() {
    var max = rail.scrollWidth - rail.clientWidth - 1;
    prev.disabled = rail.scrollLeft <= 1;
    next.disabled = rail.scrollLeft >= max;
  }

  function move(dir) {
    rail.scrollBy({ left: dir * step(), behavior: 'smooth' });
  }

  prev.addEventListener('click', function () { move(-1); });
  next.addEventListener('click', function () { move(1); });
  rail.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  [0, 400, 1200].forEach(function (ms) { setTimeout(sync, ms); });
})();


const items = [
  ['Cat Brooch','£129.00','4.9','31','New','68eb8331984699d6de9e2fb68edf652f_2944e110-f13d-4a2a-beb3-1f80fb1bff2c.jpg'],
  ['Enamel Orb Pendant','£319.00','5.0','18','','68eb8331984699d6de9e2fb68edf652f_9b45ef35-458c-4fdf-b567-222385150aa7.jpg'],
  ['Geometric Filigree Earrings','£199.00','4.8','44','Bestseller','68eb8331984699d6de9e2fb68edf652f_766eb2a0-714a-4664-92ab-8584ff152220.jpg'],
  ['Lace Crown Ring','£89.00','4.7','26','','68eb8331984699d6de9e2fb68edf652f_a9810b2d-998e-4e4a-928f-7d825ab4f5a0.jpg'],
  ['Butterfly Wing Brooch','£199.00','4.9','37','','68eb8331984699d6de9e2fb68edf652f_92377e1d-e9ca-4348-ae4b-e1cbd39fc62c.jpg'],
  ['Pearl Bow Necklace','£169.00','4.8','22','','68eb8331984699d6de9e2fb68edf652f_116a3d58-4477-4154-a0ff-f2d0bac05984.jpg'],
  ['Geometric Fan Earrings','£239.00','5.0','15','New','geometric-fan-earrings_38349b7e-7ec2-4d09-aabf-4968ef608eeb.jpg'],
  ['Leaf Ring','£79.00','4.7','29','','68eb8331984699d6de9e2fb68edf652f_b9b50d08-4d61-4480-9f97-b0c1b76c4a5a.jpg'],
  ['Orchid Wood Necklace','£199.00','4.9','33','','68eb8331984699d6de9e2fb68edf652f_5d821142-c3f4-40ce-b903-93d6e7b95ea1.jpg'],
  ['Butterfly Pearl Brooch','£189.00','4.8','21','','68eb8331984699d6de9e2fb68edf652f_c60b9782-0e06-48ca-997a-b6a3230e7ca1.jpg'],
];
document.getElementById('products').innerHTML = items.map(([n,p,r,c,tag,f])=>`
  <div class="pcard">
    <div class="thumb">
      <img src="https://cdn.shopify.com/s/files/1/0768/9735/3902/files/${f}" alt="${n}">
      ${tag?`<span class="tag">${tag}</span>`:''}
      <div class="quick">Quick add</div>
    </div>
    <h3>${n}</h3>
    <div class="price">${p}</div>
  </div>`).join('');


  } catch(e) { console.error(e); }
})();
})();
